import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { deleteColor, getColorById } from "../../../api/colorService";
import { getErrorMessage } from "../../../utils/errorHandler";
import FullPageLoader from "../../../common/FullPageLoader";
import RecordActions from "../../Shared/RecordActions";

export default function ViewColor() {
  const location = useLocation();
  const navigate = useNavigate();
  const { id: routeId } = useParams();
  const id = location?.state?.colorId || routeId;

  const [color, setColor] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchColor = async () => {
    try {
      setLoading(true);

      const response = await getColorById(id);

      setColor(response?.data || response);
    } catch (error) {
      console.error("Error fetching color:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchColor();
    }
  }, [id]);

  if (loading) {
    return <FullPageLoader text="Loading color..." />;
  }

  if (!color) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body text-center py-4">
            Color not found
          </div>
        </div>
      </div>
    );
  }

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this color?")) return;

    try {
      await deleteColor(id);
      navigate("/color");
    } catch (error) {
      alert(getErrorMessage(error));
    }
  };

  return (
    <div className="container-fluid p-4">
      <div className="card p-3 d-flex justify-content-between">
        <RecordActions
          onBack={() => navigate("/color")}
          onEdit={() =>
            navigate(`/color/edit/${color.name}`, {
              state: { colorId: id },
            })
          }
          onDelete={handleDelete}
        />

        <div className="row g-3">
  <div className="col-md-4">
    <span className="fw-bold">Color Name : </span>
    {color.name || "N/A"}
  </div>

  <div className="col-md-4">
    <span className="fw-bold">Hex Code : </span>
    {color.hexCode || "N/A"}
  </div>

  <div className="col-md-4">
    <span className="fw-bold">Status : </span>
    <span
      className={`badge ${
        color.status === "ACTIVE"
          ? "bg-success"
          : "bg-danger"
      }`}
    >
      {color.status || "INACTIVE"}
    </span>
  </div>

        </div>
      </div>
    </div>
  );
}
